import {h, Component} from 'preact'
import Button from '../ui-components/Button'
import TextButton from '../ui-components/TextButton'
import Icon from '../assets'
import {GenericHomepageElementTypes, HomepageElement} from '../homepage'
import WidgetColumn from './widget-column'
import { subscribe } from '../../utils/globals'
import Axios from 'axios'
import tracker from '../../components/tracker/publish'
import { widgetsToAddFullWidth } from './new-button'
import browser from '../../libs/helpers/browser-detection'

interface Props {
  elements: Array<HomepageElement>,
  controlUrl: string
}

export type ElementChange = Pick<HomepageElement, 'type' | 'config' | 'title'>

export type DonePayload = {idx: number, element: ElementChange}
export type MovePayload = {direction: 'up' | 'down'}
export type VisiblePayload = boolean

interface State {
  elements: Array<HomepageElement>,
  expanded: boolean,
  hideToolbar: boolean
}

export default class CustomizationToolbar extends Component<Props, State> {
  counter: number
  constructor(props: Props) {
    super()
    this.state = {
      elements: props.elements.map((el, idx) => Object.assign(
        {},
        el,
        {id: idx}
      )),
      expanded: true,
      hideToolbar: false
    }

    this.counter = 1

    subscribe('edit_column', (payload) => {
      this.setState({hideToolbar: payload.editing})
    })
  }

  componentDidMount() {
    setInterval(() => {
      ++this.counter
    }, 60000)
  }

  trackPublishEvent() {
    const isHtmlWidgetEnabled = this.state.elements.filter(element => element.type === 'html_widget' && element.active).length > 0
    const viewport = `${window.innerWidth}*${window.innerHeight}`
    tracker.trackEvent('userevent', {
      type: 'Destination Configuration Mode Published',
      browser: browser,
      viewport: viewport,
      html_widget_enabled: isHtmlWidgetEnabled,
      session_time: this.counter
    })
  }

  trackCancelEvent() {
    const viewport = `${window.innerWidth}*${window.innerHeight}`
    tracker.trackEvent('userevent', {
      type: 'Destination Configuration Mode Cancelled',
      browser: browser,
      viewport: viewport,
      session_time: this.counter
    })
  }

  render() {
    let widgetList: Array<widgetsToAddFullWidth> = [
      {
        type: 'hero_banner',
        title: 'Hero Banner',
        description: 'An image banner with headline and search bar'
      },
      {
        type: GenericHomepageElementTypes.statistics_bar,
        title: 'Statistics Bar',
        description: 'Community statistics and recently online'
      },
      {
        type: GenericHomepageElementTypes.introduction_bar,
        title: 'Introduction Bar',
        description: 'Community introduction for new users'
      }, {
        type: 'quick_links',
        title: 'Quick Links',
        description: 'Add links to the homepage'
      },
      {
        type: 'knowledge_base',
        title: 'Knowledge Base',
        description: 'Navigation cards to knowledge base parent categories'
      },
      {
        type: 'community_category',
        title: 'Community Category',
        description: 'Navigation cards to community parent categories'
      },
      {
        type: 'featured_topics',
        title: 'Featured topics',
        description: 'Highlight curated topics in card style'
      },
      {
        type: GenericHomepageElementTypes.feature_topics,
        title: 'Featured topics (moderator tags)',
        description: 'Curate topics with moderator tags'
      },
      {
        type: 'recommendations',
        title: 'Recommendations',
        description: 'Highlight curated topics in list style'
      },
      {
        type: 'category_and_topics_stream_only',
        title: 'Tabs',
        description: 'Browse community categories and topics'
      },
      {
        type: 'container_2_1',
        title: 'Container 2:1',
        description: 'Page layout option'
      },
      {
        type: 'html_widget',
        title: 'HTML widget',
        description: 'Add widget with custom HTML code'
      }
    ]

    const hasFeatureTopics = this.state.elements.findIndex(element => element.type === 'feature_topics')

    if (hasFeatureTopics !== -1) {
      const featureTopicsIndex = widgetList.findIndex(element => element.type === 'feature_topics') // There will be more dynamic items so checking the index again instead of hard code 3

      widgetList.splice(featureTopicsIndex, 1)
    }

    return <div class={`translation--switch customization-toolbar ${this.state.hideToolbar ? 'is-hidden' : ''}`}>
      <div class={`customization-toolbar__expanded-controls ${this.state.expanded ? 'customization-toolbar__expanded-controls--expanded' : ''}`}>
        <span class='customization-toolbar__dot' />

        <span style={{marginRight: '16px'}}>Customization Mode</span>

        <Button insided small style={{marginRight: '8px'}} onClick={async () => {
          this.trackPublishEvent()
          await Axios.post('/branding/updateWidgets', {
            elements: this.state.elements
          })
          window.location.href = '/'
        }} qaClasses='qa-save-customization'>Publish</Button>
        <Button small insidedSecondary style={{marginRight: '8px'}} onClick={() => {
          this.trackCancelEvent()
          window.location.href = '/'
          }}>Cancel</Button>
      </div>

      <TextButton style={{
        display: 'flex',
        alignItems: 'center',
        paddingRight: '8px',
        paddingLeft: '8px'
        }} onClick={() => this.setState({expanded: !this.state.expanded})}>
        <Icon size={14} color='#6B707E' icon={this.state.expanded ? 'chevronRight' : 'chevronLeft'} />
      </TextButton>

      <WidgetColumn
        classPrefix='homepage-widget-container--index-'
        container='.body-wrapper'
        controlUrl={this.props.controlUrl}
        widgetList={widgetList}
        elements={this.state.elements}
        onChange={elements => this.setState({elements})}
        nested={false}
      />
    </div>
  }
}
